<template>
    <div class="page-staff-detail">
      <staff-detail />
    </div>
  </template>
  
  <script>
  import StaffDetail from '@/components/details/StaffDetail.vue'
  
  export default {
    name: 'ViewStaffDetail',
    components: {
      StaffDetail,
    },
  
    data() {
      return {
        pageName: 'StaffDetail',
      }
    },
  
    created(){
  
    },
  
    mounted(){
      this.$eventBus.emit('page-change', {
        target: this,
        currentRoute: this.$router.currentRoute.value
      })
    },
    
  }
  </script>